"use client";

import { useEffect } from "react";

/** Pulls Swiper CSS after hydration so it is not render-blocking for the document. */
export function LoadDeferredSwiperStyles() {
  useEffect(() => {
    void import("swiper/css");
    void import("swiper/css/navigation");
    void import("swiper/css/pagination");
  }, []);
  return null;
}
